import { TypeValidator } from './type-validator';
import { EnumValidator } from './enum-validator';
import { CustomValidator } from './custom-validator';
import { EffectKeyValidator } from './effect-key-validator';

export const ConfiguredValidators = [
  TypeValidator,
  EnumValidator,
  CustomValidator,
  EffectKeyValidator,
];
